import Minze, { EventListeners, MinzeElement, Reactive } from 'minze'
import { isMobile } from '../../../../modules/utils'
import { Locale } from '../../../../modules/locale'
import MainModule from '../../../../modules/main'
Locale.getInstance().registerKeySet('fr', 'searchButton', {
  search: 'Rechercher',
})
Locale.getInstance().registerKeySet('en', 'searchButton', {
  search: 'Search',
})
export class LvcSearchMenuButton extends MinzeElement {
  reactive: Reactive = ['isOpen']
  handleOnClick = async () => {
    try {
      const mainModule = MainModule.getInstance()
      const isSearchPage =
        mainModule.getRouting().getCurrentPage() ===
        mainModule.getRouting().getRoute('searchResults')
      await mainModule.analyticsTrack('cta_rechercher', {
        emplacement: isSearchPage ? 'recherche' : 'menu principal',
      })
    } catch (error) {
      console.error('Error tracking analytics:', error)
    }
    Minze.cast('lvc:search-menu-button-clicked')
  }
  handleMenuStateChange = (e: CustomEvent) => {
    if (e.type !== 'lvc:search-menu-state-changed') return
    document.body.style.overflowY = e.detail.isOpen && isMobile() ? 'hidden' : 'auto'
    this.isOpen = e.detail.isOpen
  }
  html = () => `
    ${menuButtonIcon}
    <div>${Locale.getKey('searchButton.search')}</div>
  `
  css = () => `
    :host {
      background-color: ${this.isOpen ? '#dcffd7' : 'none'};
      padding: 0 24px;
      display: flex;
      align-items: center;
      gap: 4px;
      font-size: 14px;
      cursor: pointer;
      user-select: none;
      height: 100%;
    }
    @media screen and (max-width: 991px) {
      :host {
        padding: 0 4px;
        flex-direction: column;
        justify-content: center;
        font-size: 10px;
      }
    }
    .svg-icon {}
  `
  eventListeners: EventListeners = [
    [this, 'click', this.handleOnClick],
    [window, 'lvc:search-menu-state-changed', e => this.handleMenuStateChange(e as CustomEvent)],
  ]
}
const menuButtonIcon = `
  <svg class='svg-icon' width="33" height="32" viewBox="0 0 33 32" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M5.68865 10.9055L4.75972 10.5353H4.75972L5.68865 10.9055ZM9.74314 8.00192C10.2264 7.73459 10.4015 7.12611 10.1341 6.64283C9.86682 6.15956 9.25834 5.9845 8.77506 6.25183L9.74314 8.00192ZM7.39118 5.57792C6.96053 5.92369 6.89172 6.55311 7.23749 6.98376C7.58327 7.41441 8.21268 7.48322 8.64333 7.13744L7.39118 5.57792ZM15.3365 4.0035L15.3608 5.00321L15.3365 4.0035ZM22.5224 6.227L23.1353 5.43682C23.1267 5.43016 23.118 5.42363 23.1092 5.41725L22.5224 6.227ZM26.2303 11.6276L27.189 11.3432V11.3432L26.2303 11.6276ZM26.0535 18.1307L26.9896 18.4824C26.9915 18.4771 26.9935 18.4719 26.9954 18.4665L26.0535 18.1307ZM21.9291 23.2304L21.3858 22.3909H21.3858L21.9291 23.2304ZM15.5174 24.9488L15.566 23.9499L15.5639 23.9498L15.5174 24.9488ZM5.23283 17.3371L4.26111 17.5732C4.26336 17.5825 4.26574 17.5917 4.26826 17.6009L5.23283 17.3371ZM28.2145 28.6955C28.5986 29.0923 29.2317 29.1027 29.6286 28.7186C30.0254 28.3345 30.0358 27.7014 29.6517 27.3045L28.2145 28.6955ZM6.61758 11.2758C7.088 10.0956 8.44848 8.71807 9.74314 8.00192L8.77506 6.25183C7.19496 7.12587 5.44553 8.81466 4.75972 10.5353L6.61758 11.2758ZM8.64333 7.13744C10.4114 5.71785 12.912 5.06275 15.3608 5.00321L15.3122 3.0038C12.5977 3.0698 9.61529 3.79216 7.39118 5.57792L8.64333 7.13744ZM15.3608 5.00321C17.7254 4.94571 20.0395 5.66268 21.9356 7.03674L23.1092 5.41725C20.8553 3.78395 18.1111 2.93574 15.3122 3.0038L15.3608 5.00321ZM21.9095 7.01717C23.5255 8.27059 24.6991 9.98213 25.2716 11.912L27.189 11.3432C26.496 9.00695 25.0778 6.94344 23.1353 5.43682L21.9095 7.01717ZM25.2716 11.912C25.844 13.8416 25.7882 15.8973 25.1115 17.7948L26.9954 18.4665C27.8143 16.1698 27.8821 13.6798 27.189 11.3432L25.2716 11.912ZM25.1174 17.7789C24.4098 19.6621 23.1038 21.2791 21.3858 22.3909L22.4723 24.07C24.545 22.7287 26.1292 20.7721 26.9896 18.4824L25.1174 17.7789ZM21.3858 22.3909C19.6674 23.5029 17.6282 24.0501 15.566 23.9499L15.4689 25.9476C17.9463 26.0679 20.4 25.411 22.4723 24.07L21.3858 22.3909ZM15.5639 23.9498C11.3311 23.7532 7.28257 21.0412 6.19741 17.0733L4.26826 17.6009C5.62855 22.5748 10.5619 25.7196 15.471 25.9477L15.5639 23.9498ZM6.20456 17.101C5.73386 15.1637 5.87766 13.1321 6.61758 11.2758L4.75972 10.5353C3.86642 12.7764 3.69222 15.2318 4.26111 17.5732L6.20456 17.101ZM22.5795 22.8732L28.2145 28.6955L29.6517 27.3045L24.0166 21.4823L22.5795 22.8732Z" fill="#1E007D"/>
  </svg>
`
